const theme = {
  Colors: {
    PRIMARY: '#006BD3',
    WHITE: '#fff',
  },
};

export default theme;
